import router from '../router'
import store from '../store'
import NProgress from 'nprogress' // progress bar

// NProgress.configure({ showSpinner: false })// NProgress configuration

const whiteList = ['/login'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  NProgress.start();
  var token = store.state.token;
  var user = store.state.user;

  if (token) {
    store.dispatch('reqUpdateUserInfo');

    if (to.path === '/login') {
      next('/home');
    } else {
      next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next({ path: '/login' });
    }
  }

})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/utils/permission.js